// Code review - Completed
// Documentation - Completed
import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import MainPopup from "../popup-containers/MainPopup";
import InputText from "../ReusableComponents/InputText";
const TableWithCheckBox = ({
  tableHeight,
  headerData,
  tableData,
  onViewGrid,
  onEditGrid,
  onDeleteGrid,
  onBlockGrid,
  currentPage,
  itemsPerPage,
  viewBag,
  editBag,
  deleteBag,
  blockBag,
  onSelectedGrid,
  checkBoxStatus,
  selectedRows,
  checkBoxVisible,
  checkBoxHeaderVisible,
  isMultiSelect,
  onLaundryIssueView,
  onSpaceDatas,
  onSpaceDataClear,
  onSpaceDataClearFalse,
  onAmenitiesDatas,
}) => {

  let currentData = [];

  const [startIndex, setStartIndex] = useState(0);

  const [spaceQuantity, setSpaceQuantity] = useState(Array(tableData.length).fill(""));
  const [spaceDate, setSpaceDate] = useState(Array(tableData.length).fill(""));
  const [spaceData, setSpaceData] = useState([]);


  const [amenitiesQuantity, setAmenitiesQuantity] = useState(Array(tableData.length).fill(""));
  const [amenitiesDate, setAmenitiesDate] = useState(Array(tableData.length).fill(""));
  const [amenitiesData, setAmenitiesData] = useState([]);

  const [disabled, setDisabled] = useState(Array(tableData.length).fill(true));




  if (currentPage) {
    if (Array.isArray(tableData)) {
      if (itemsPerPage === -1) {
        currentData = tableData; // No slicing, show all data
      } else {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        currentData = tableData.slice(startIndex, endIndex); // Pagination logic
      }
    }
  } else {
    currentData = [tableData];
  }
  const [viewsAll, setViewsAll] = useState(false);
  const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false);
  const [viewImage, setViewImage] = useState({ popup: false, url: "" });
  // const [selectedRows, setSelectedRows] = useState([]);
  const [currentRowIndex, setCurrentRowIndex] = useState(null);
  const showPopUp = (views, rowIndex) => {
    setViewsAll(views);
    setCurrentRowIndex(views ? rowIndex : null);
  };


  const handleHeaderCheckboxChange = () => {
    const allIndexes = tableData.map((_, idx) => idx);
    const isAllSelected = selectedRows.length === tableData.length;
    setIsHeaderCheckboxChecked(!isAllSelected);
    const newSelection = isAllSelected ? [] : allIndexes;
    checkBoxStatus(newSelection); // update parent
    setIsHeaderCheckboxChecked(!isAllSelected);

    // Update disabled state: only selected rows are enabled
    const newDisabled = tableData.map((_, idx) => !newSelection.includes(idx));
    setDisabled(newDisabled);
  };

  const handleRowCheckboxChange = (rowIndex) => {
    let updatedSelectedRows = [];

    if (isMultiSelect) {
      updatedSelectedRows = [...selectedRows];
      const index = updatedSelectedRows.indexOf(rowIndex);

      if (index > -1) {
        updatedSelectedRows.splice(index, 1);
      } else {
        updatedSelectedRows.push(rowIndex);
      }
    } else {
      if (selectedRows?.[0] === rowIndex) {
        updatedSelectedRows = [];
      } else {
        updatedSelectedRows = [rowIndex];
      }
    }

    if (typeof checkBoxStatus === "function") {
      checkBoxStatus(updatedSelectedRows);
    }

    const isAllChecked = updatedSelectedRows.length === tableData.length;
    setIsHeaderCheckboxChecked(isAllChecked);

    const selectedRowData = updatedSelectedRows.map((i) => tableData[i]);

    if (typeof onSelectedGrid === "function") {
      onSelectedGrid(selectedRowData);
    }

    // Update disabled state: only selected rows are enabled
    const newDisabled = tableData.map((_, idx) => !updatedSelectedRows.includes(idx));
    setDisabled(newDisabled);
  };




  const handleSpace = (rowIndex, quantity, date) => {
    const updatedRow = {
      ...tableData[rowIndex],
      RowIndex: rowIndex,
      SpaceCount: quantity,
      Date: date,
    };
    console.log("updatedRow", updatedRow);
    setSpaceData((prev) => {
      const existingIndex = prev.findIndex((row) => row.RowIndex === rowIndex);
      if (existingIndex !== -1) {
        const newData = [...prev];
        newData[existingIndex] = updatedRow;
        return newData;
      } else {
        return [...prev, updatedRow];
      }
    });
  };

  const spaceDateChange = (rowIndex, value) => {
    const updatedDate = [...spaceDate];
    updatedDate[rowIndex] = value;
    setSpaceDate(updatedDate);

    const currentQuantity = spaceQuantity[rowIndex]; // still may be old
    handleSpace(rowIndex, currentQuantity, value); // use passed date
  };

  const spaceQuantityChange = (rowIndex, value) => {
    const updatedQty = [...spaceQuantity];
    updatedQty[rowIndex] = value;
    setSpaceQuantity(updatedQty);

    const currentDate = spaceDate[rowIndex]; // still may be old
    handleSpace(rowIndex, value, currentDate); // use passed quantity
  };

  const handleAmenities = (rowIndex, quantity, date) => {
    const updatedRow = {
      ...tableData[rowIndex],
      RowIndex: rowIndex,
      AmenitiesCount: quantity,
      Date: date,
    };
    console.log("updatedRow", updatedRow);
    setAmenitiesData((prev) => {
      const existingIndex = prev.findIndex((row) => row.RowIndex === rowIndex);
      if (existingIndex !== -1) {
        const newData = [...prev];
        newData[existingIndex] = updatedRow;
        return newData;
      } else {
        return [...prev, updatedRow];
      }
    });
  };

  const amenitiesDateChange = (rowIndex, value) => {
    const updatedDate = [...amenitiesDate];
    updatedDate[rowIndex] = value;
    setAmenitiesDate(updatedDate);

    const currentQuantity = amenitiesQuantity[rowIndex]; // still may be old
    handleAmenities(rowIndex, currentQuantity, value); // use passed date
  };

  const amenitiesQuantityChange = (rowIndex, value) => {
    const updatedQty = [...amenitiesQuantity];
    updatedQty[rowIndex] = value;
    setAmenitiesQuantity(updatedQty);

    const currentDate = amenitiesDate[rowIndex]; // still may be old
    handleAmenities(rowIndex, value, currentDate); // use passed quantity
  };

  useEffect(() => {

    if (spaceData.length != 0) {
      onSpaceDatas(spaceData)
    }
  }, [spaceData]);

  useEffect(() => {

    if (amenitiesData.length != 0) {
      onAmenitiesDatas(amenitiesData)
    }
  }, [amenitiesData]);

  useEffect(() => {
    
    if (onSpaceDataClear) {
      setSpaceQuantity(Array(tableData.length).fill(""));
      setSpaceDate(Array(tableData.length).fill(""));
      setSpaceData([]);

      setAmenitiesQuantity(Array(tableData.length).fill(""));
      setAmenitiesDate(Array(tableData.length).fill(""));
      setAmenitiesData([]);
      onSpaceDataClearFalse(true);
      setDisabled(Array(tableData.length).fill(true));
    }
  }, [onSpaceDataClear ? onSpaceDataClear : null]);

  useEffect(() => {

    setDisabled(Array(tableData.length).fill(true));

    if (tableData.length > 0) {

      const spaceCount = [...spaceQuantity];
      const spaceDateValue = [...spaceDate];

      const amenitiesCount = [...amenitiesQuantity];
      const amenitiesDateValue = [...amenitiesDate];

      if (!Array.isArray(tableData)) return;
      tableData.forEach((data, index) => {


        if (data?.SpaceCount != '') {
          spaceCount[index] = data?.SpaceCount ?? "";

          const rawDate = data?.Date ?? "";
          spaceDateValue[index] = rawDate ? rawDate.split("T")[0] : "";
        }


        if (data?.AmenitiesCount != '') {
          amenitiesCount[index] = data?.AmenitiesCount ?? "";

          const rawDate = data?.Date ?? "";
          amenitiesDateValue[index] = rawDate ? rawDate.split("T")[0] : "";
        }

      });

      setSpaceQuantity(spaceCount);
      setSpaceDate(spaceDateValue);
      setAmenitiesDate(amenitiesDateValue);
      setAmenitiesQuantity(amenitiesCount);
    }

  }, [tableData]);

  return (
    <div className={`${mainTable.tableShadowWidth}`}>
      <div className={mainTable.table} role="table">
        <div className={mainTable.tableHeader} role="rowgroup">
          {/* {checkBoxHeaderVisible && ( */}
          <div className="px-2 py-2 md:py-3 flex bg-[#3D6643]">
            {/* <input
                type="checkbox"
                checked={isHeaderCheckboxChecked}
                onChange={handleHeaderCheckboxChange}
              /> */}
            <input
              type="checkbox"
              checked={selectedRows?.length === tableData?.length && tableData?.length > 0}
              onChange={handleHeaderCheckboxChange}
              disabled={!checkBoxHeaderVisible}
            />
          </div>
          {/* )} */}

          {headerData.map((item, itemIndex) => (
            <div key={itemIndex} className={item.width} role="columnheader">
              <label className="text-sm font-medium">{item.title}</label>
            </div>
          ))}
        </div>

        <div
          className={`overflow-y-auto ${tableHeight ? tableHeight : "h-96"} `}
        >
          {currentData.length > 0 &&
            currentData.map((data, rowIndex) => (
              <div class={mainTable.tableRow}>
                <div className="px-2 py-2  md:py-3 flex bg-white">
                  {checkBoxVisible && (
                    // <input
                    //   type="checkbox"
                    //   checked={
                    //     isHeaderCheckboxChecked ||
                    //     (selectedRows?.includes(rowIndex) ?? false)
                    //   }
                    //   onChange={() => handleRowCheckboxChange(rowIndex)}
                    // />
                    <input
                      type="checkbox"
                      checked={selectedRows?.includes(rowIndex) ?? false}
                      onChange={() => handleRowCheckboxChange(rowIndex)}
                    />
                  )}
                </div>
                {headerData.map((keyData) => (
                  <div scope="cell" role="cell" className={keyData.width}>
                    {keyData.key === "action" ? (
                      <div>
                        <button
                          id="dropdownMenuIconButton"
                          data-dropdown-toggle="dropdownDots"
                          class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none "
                          type="button"
                          onClick={() => showPopUp(!viewsAll, rowIndex)}
                        >
                          <svg
                            class="w-6 h-6"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                          </svg>
                        </button>
                        {viewsAll && currentRowIndex == rowIndex && (
                          <div
                            id="dropdownDots"
                            class="z-10 bg-white absolute right-14 divide-y divide-gray-100 rounded-lg shadow w-44 "
                          >
                            <ul
                              class=""
                              aria-labelledby="dropdownMenuIconButton"
                            >
                              {viewBag == 1 && (
                                <li>
                                  <a
                                    onClick={() => {
                                      onViewGrid(
                                        startIndex +
                                        rowIndex +
                                        (currentPage - 1) * itemsPerPage,
                                        1
                                      );
                                      showPopUp(false);
                                    }}
                                    class="block px-4 py-2 hover:bg-gray-100 "
                                  >
                                    View
                                  </a>
                                </li>
                              )}
                              {editBag == 1 && !data.InActivatedBy && (
                                <li>
                                  <a
                                    onClick={() => {
                                      onEditGrid(data.oldIndex, 2);
                                      showPopUp(false);
                                    }}
                                    class="block px-4 py-2 hover:bg-gray-100"
                                  >
                                    Edit
                                  </a>
                                </li>
                              )}
                              {deleteBag == 1 && (
                                <li>
                                  <a
                                    onClick={() => {
                                      onDeleteGrid(data.oldIndex, 3);
                                      showPopUp(false);
                                    }}
                                    class="block px-4 py-2 hover:bg-gray-100"
                                  >
                                    Delete
                                  </a>
                                </li>
                              )}
                              {blockBag == 1 && (
                                <li>
                                  {data.InActivatedBy ? (
                                    <a
                                      onClick={() => {
                                        onBlockGrid(data.oldIndex, 5);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Make Active
                                    </a>
                                  ) : (
                                    <a
                                      onClick={() => {
                                        onBlockGrid(data.oldIndex, 4);
                                        showPopUp(false);
                                      }}
                                      class="block px-4 py-2 hover:bg-gray-100"
                                    >
                                      Make Inactive
                                    </a>
                                  )}
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    ) : keyData.key === "SpaceDate" ? (
                      <div>
                        <InputText
                          key={rowIndex}
                          inputType="date"
                          content={spaceDate[rowIndex]}
                          controlFunc={(e) => spaceDateChange(rowIndex, e.target.value)}
                          disabled={disabled[rowIndex]}
                        />
                      </div>
                    ) : keyData.key === "SpaceCount" ? (
                      <div>
                        <InputText
                          inputType="text"
                          inputMode="numeric" // Mobile-friendly number keyboard
                          pattern="[0-9]*"     // Restricts to digits
                          maxLength={2}
                          content={spaceQuantity[rowIndex]}
                          controlFunc={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              spaceQuantityChange(rowIndex, value);
                            }
                          }}
                          disabled={disabled[rowIndex]}
                        />
                      </div>
                    ) : keyData.key === "AmenitiesDate" ? (
                      <div>
                        <InputText
                          key={rowIndex}
                          inputType="date"
                          content={amenitiesDate[rowIndex]}
                          controlFunc={(e) => amenitiesDateChange(rowIndex, e.target.value)}
                          disabled={disabled[rowIndex]}
                        />
                      </div>
                    ) :
                      keyData.key === "AmenitiesCount" ? (
                        <div>
                          <InputText
                            inputType="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={2}
                            content={amenitiesQuantity[rowIndex]}
                            controlFunc={(e) => {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                amenitiesQuantityChange(rowIndex, value);
                              }
                            }}
                            disabled={disabled[rowIndex]}
                          />
                        </div>
                      ) :
                        keyData.title === "S.No." ? (
                          <div>
                            {startIndex +
                              rowIndex +
                              1 +
                              (currentPage - 1) * itemsPerPage}
                          </div>
                        ) : keyData.title === "S.No." && data.InActivatedBy ? (
                          <div class={keyData.width1}>
                            {startIndex +
                              rowIndex +
                              1 +
                              (currentPage - 1) * itemsPerPage}
                          </div>
                        ) : keyData.key === "RowNumber" ? (
                          <div title={data[keyData.key]}>
                            {data[keyData.key] != "" ? data[keyData.key] : ""}
                          </div>
                        )

                          : keyData.key === "Attachment" ? (

                            <div className="flex flex-col gap-2">
                              <button
                                id="dropdownMenuIconButton"
                                data-dropdown-toggle="dropdownDots"
                                type="button"
                                className="w-full h-9 bg-[#3D6643] text-white hover:text-gray-800 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-[#24292F]/50 font-medium rounded-lg text-sm px-5 py-2.5 flex items-center justify-center"
                                onClick={() => onViewGrid(rowIndex)}
                              >
                                View
                              </button>

                            </div>
                          ) : keyData.key === "LaundryIssueView" ? (
                            <div>
                              <a
                                href="#"
                                className="text-[#3D6643] underline cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  onLaundryIssueView(data.oldIndex, 2);
                                  showPopUp(false);
                                }}
                              >
                                View
                              </a>
                            </div>
                          )

                            : (
                              <div class="relative">
                                <div
                                  class="truncate relative"
                                  title={data[keyData.key]}
                                >
                                  {data[keyData.key]}
                                </div>
                                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                </div>
                              </div>
                            )}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>

      <div className={mainTable.tableMobile} role="table">
        <div className="w-full md:overflow-y-auto lg:h-96 h-full">
          {checkBoxHeaderVisible && (
            <div className="px-2 py-2 md:py-3 flex bg-[#3D6643]">
              <input
                type="checkbox"
                checked={isHeaderCheckboxChecked}
                onChange={handleHeaderCheckboxChange}
              />
            </div>
          )}
          {currentData.length > 0 &&
            currentData.map((data, rowIndex) => (
              <div scope="col" class={mainTable.mobileTable}>
                {headerData.map((keyData) => (
                  <div scope="cell" class={mainTable.tableData} role="cell">
                    {keyData.key === "action" || keyData.key === "action1" ? (
                      <div class={mainTable.tableData}>
                        <div className="md:block hidden">
                          <button
                            id="dropdownMenuIconButton"
                            data-dropdown-toggle="dropdownDots"
                            class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none "
                            type="button"
                            onClick={() => showPopUp(!viewsAll, rowIndex)}
                          >
                            <svg
                              class="w-6 h-6"
                              aria-hidden="true"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="md:hidden block flex justify-center">
                          {viewBag === 1 && (
                            <button
                              className="bg-[#213F99] text-white mr-1 p-1 rounded-lg"
                              onClick={() =>
                                onViewGrid(
                                  startIndex +
                                  rowIndex +
                                  (currentPage - 1) * itemsPerPage,
                                  1
                                )
                              }
                            >
                              View
                            </button>
                          )}
                        </div>
                      </div>
                    ) : keyData.key === "Attachment" ? (
                      <div className="flex flex-col gap-2">
                        <button
                          id="dropdownMenuIconButton"
                          data-dropdown-toggle="dropdownDots"
                          type="button"
                          className="w-full h-9 bg-[#3D6643] text-white hover:text-gray-800 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-[#24292F]/50 font-medium rounded-lg text-sm px-5 py-2.5 flex items-center justify-center"
                          onClick={() => onViewGrid(rowIndex)}
                        >
                          View
                        </button>
                      </div>
                    ) : keyData.title === "S.No." ? (
                      <div className="flex border p-1">
                        <div className="flex basis-1/2">
                          {checkBoxVisible && (
                            <input
                              type="checkbox"
                              className="border-4 border-[#1f2a44]"
                              checked={
                                isHeaderCheckboxChecked ||
                                (selectedRows?.includes(rowIndex) ?? false)
                              }
                              onChange={() => handleRowCheckboxChange(rowIndex)}
                            />
                          )}
                        </div>
                        <div className="flex justify-center">
                          {rowIndex + 1}
                        </div>
                      </div>
                    ) : (
                      <div className="grid max-md:grid-cols-2 border p-1">
                        <div className="font-bold whitespace-pre-wrap break-words">
                          {keyData.title}
                        </div>
                        <div className="whitespace-pre-wrap break-words">
                          {data[keyData.key]}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
      <MainPopup
        popUpOpen={viewImage.popup}
        setpopUpOpen={() => setViewImage({ popup: false, url: "" })}
      >
        <div>
          <button class="w-full">
            <span
              className="text-white flex justify-end"
              onClick={() => setViewImage({ popup: false, url: "" })}
              class="text-2xl p-0 m-o block float-right mr-3"
            >
              &times;
            </span>
          </button>
          <div className="flex justify-center p-12 items-center">
            <img src={viewImage.url} class={"w-96 h-96"} />
          </div>
        </div>
      </MainPopup>
    </div>
  );
};

export default TableWithCheckBox;
